import React, { useState } from "react";
import { forgotPassword } from "../../../service/applicatif/acount";
import { useHistory } from "react-router-dom";

export default function useForgotPasswordCtr() {
  const [email, setEmail] = useState<string>("");
  const [emailTemp, setEmailTemp] = useState<string>("");
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const [emailNotExist, setEmailNotExist] = useState<boolean>(false);
  const history = useHistory();
  const resendMailForgotPassword = async () => {
    setShowLoader(true);
    let data = {
      email,
    };
    let response = await forgotPassword(data);
    if (response?.status === 200 && response?.data) {
      setShowLoader(false);
      setEmailSent(true);
    } else {
      setEmailNotExist(true);
      setShowLoader(false);
    }
  };

  console.log("history length", history.length);

  return {
    email,
    emailTemp,
    showLoader,
    emailSent,
    emailNotExist,
    setEmailNotExist,
    setEmail,
    setEmailTemp,
    resendMailForgotPassword,
    history,
  };
}
